import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Toolbar, Tooltip, IconButton, Typography } from '@mui/material';
// component
// import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  // height: 30,
  display: 'flex',
  justifyContent: 'space-between',
  // padding: theme.spacing(0, 1, 0, 3),
}));

// ----------------------------------------------------------------------

RequestListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
};

export default function RequestListToolbar({ numSelected, filterName, onFilterName }) {
  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {/* Requests */}
        </Typography>
      )}

      {numSelected > 0 ? (
        <div>
          <Tooltip title="Assign">
            <IconButton>
              {/* <Iconify icon="clarity:assign-user-solid" /> */}
            </IconButton>
          </Tooltip>
          {/* <Tooltip title="Pick Up">
            <IconButton>
              // <Iconify icon="carbon:choose-item" />
            </IconButton>
          </Tooltip> */}
          <Tooltip title="Close">
            <IconButton>
              {/* <Iconify icon="eva:checkmark-circle-2-fill" /> */}
            </IconButton>
          </Tooltip>
          {/* <Tooltip title="Delete">
            <IconButton>
              <Iconify icon="eva:trash-2-fill" />
            </IconButton>
          </Tooltip> */}
        </div>
      ) : (
        null
        // <Tooltip title="Filter list">
        //   <IconButton>
        //     <Iconify icon="ic:round-filter-list" />
        //   </IconButton>
        // </Tooltip>
      )}
    </StyledRoot>
  );
}
